import { Injectable } from '@angular/core';
import {
  ProductListByIdsConfigService,
  Product
} from 'gung-standard';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { ColmecRimCardComponent } from '../components/buy-btn/colmec-rim-card/colmec-rim-card.component';
import { mergeMap, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColmecRimListByIdsConfigService extends ProductListByIdsConfigService {
  parentProductId: string;

  getLayouts(): ListLayout<Product>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => ColmecRimCardComponent, // ColmecJeevesProductCardComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Product grid'
      }
    ];
  }

  getSearchGroupCss(): string {
    return 'd-none';
  }

  setParentProductId(parentProductId: string) {
    this.parentProductId = parentProductId;
  }

  getItems() {
    return this.productIdsSubject.asObservable().pipe(
      mergeMap(productIds => this.productService.getProductsByIds(productIds)),
      map(productIds => {
        productIds.forEach(product => {
          product.extra.parentProductId = this.parentProductId;
        });
        return productIds;
      })
    );
  }
}
